<div #container
     class="container bg1 page-keyword {{ showDetail ? 'no-scroll' : '' }}"
     (scroll)="onScroll($event)">

  <app-header placeholder="단어(표제어)에 쓰인 사 성과 훈 풀이가 있습니다."
              showJasoIdx="true"
              [curJasoIdx]="curJasoIdx"
              [secondJaso]="false"
              [keyword]="keyword"
              [keyHistory]="HISTORY_KEY_SEARCH_SASEUNG"
              (search)="onSearch($event)"></app-header>

  <app-left-menu></app-left-menu>

  <section class="search-cn {{ (showDetail || showHunDetail) ? 'overlay' : '' }}">
    <div class="inner wrap">

      <div class="search-wrap">
        <div *ngIf="ll.getTotalCount() === 0"
             class="keyword-item-box">
          <div class="img-box">
            <img src="assets/img/img_menu_tiger.svg">
          </div>
          <div class="keyword-no-result-box">
            문자가 없습니다.
          </div>
        </div>

        <ul class="search-list">
          <li class="search-item"
              *ngFor="let hangul of ll.getList()">
            <div class="item-wrap">
              <a class="item-box"
                 (click)="onSelectItem($event, hangul)">

                <div class="txt-box">{{ hangul }}</div>
              </a>
            </div>
          </li>

        </ul>
      </div>

      <div class="reload-icon"
           *ngIf="!ll.IsComplete()">
        <img #reload src="assets/img/loading_icon.gif">
      </div>
    </div>

  </section>

  <section class="dialect-map search-detail" [@wordDetailInOut]
           *ngIf="showDetail">
    <app-saseung3-detail [hangul]="curHangul"
                        [keyword]="curKeyword"
                        [hun]="curHun"
                        [hanja]="curHanja"
                        [listType]="type"
                        (closeDetail)="onCloseItem()"
                        (openHelp)="OpenHelp()">
    </app-saseung3-detail>
  </section>

  <app-footer></app-footer>

  <!-- help popup -->
  <article class="popup popup-help" [@wordDetailInOut]
           *ngIf="lm.showHelp">
    <app-saseung3-help (closePopup)="CloseHelp()"></app-saseung3-help>
  </article>

</div>

<app-common-popups></app-common-popups>
